$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  createBurgerIcon();
  customSearchBar();
  updateSignupFeature();

  cloneCountdown();
});

// --------------------------------
// Custom burger menu
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<span class="burger-line"></span>');
  });
}

// --------------------------------
// Searchbox scripts
function customSearchBar() {
  let searchPlaceholder = 'Search Website';

  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', searchPlaceholder);
}

// --------------------------------
// clone function for countdown
function cloneCountdown() {
  const countdownMobileContainer = $('#countdown-mobile');

  setTimeout(() => {
    const isHomePage = $('body').hasClass('homepage');
    if (isHomePage) {
      $('#siteInfoBannerWidget').clone().appendTo(countdownMobileContainer);
    }
  }, 2000);
}

// --------------------------------
// Custom  signup widget
function updateSignupFeature() {
  const containerSectionClass = 'signup-section';

  const signupTitle = 'Stay Up to Date';
  const signupText = `<span>Join our mailing list and never miss an update!</span> 
    <span>Keep up with all events, important dates and artist lineups.</span>`;
  const inputPlaceholder = 'Email Address';
  const buttonLabel = 'Learn More';

  const $signupElement = $(`.${containerSectionClass} .emailSignup`);
  const $signupText = $signupElement.find('.emailSignupText');

  $signupText.replaceWith(`
    <div class="signup-text">
      <h2 class="signup-title">${signupTitle}</h2>
      <p class="signup-description">${signupText}</p>
    </div>
    `);

  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-container"></div>');
  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);
  $signupElement.find('.emailInputSubmit a').text(buttonLabel);
}

// --------------------------------
// --------------------------------
// function to validate external Links
export function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

export function validateWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(window).width() >= breakpoint;
}
